import React from "react";
import { motion } from "framer-motion";
import { Check, Minus } from "@phosphor-icons/react";
import { cn } from "./cn";

export default function Checkbox({
  checked = false,
  indeterminate = false,
  onChange,
  label,
  description,
  disabled = false,
  size = 18,
  className,
}) {
  const on = checked || indeterminate;
  return (
    <button
      type="button"
      role="checkbox"
      aria-checked={indeterminate ? "mixed" : !!checked}
      disabled={disabled}
      onClick={() => onChange?.(!checked)}
      className={cn(
        "inline-flex items-start gap-2.5 text-start outline-none",
        disabled ? "cursor-not-allowed opacity-50" : "cursor-pointer",
        className
      )}
    >
      <span
        className={cn(
          "mt-0.5 grid shrink-0 place-items-center rounded-md border transition-colors",
          "focus-visible:ring-2 focus-visible:ring-accent/40",
          on ? "border-accent bg-accent text-accent-fg" : "border-line bg-surface hover:border-faint"
        )}
        style={{ width: size, height: size }}
      >
        <motion.span
          initial={false}
          animate={{ scale: on ? 1 : 0, opacity: on ? 1 : 0 }}
          transition={{ type: "spring", stiffness: 600, damping: 28 }}
          className="grid place-items-center"
        >
          {indeterminate ? (
            <Minus size={Math.round(size * 0.72)} weight="bold" />
          ) : (
            <Check size={Math.round(size * 0.72)} weight="bold" />
          )}
        </motion.span>
      </span>
      {(label || description) && (
        <span className="leading-tight">
          {label && <span className="block text-sm text-ink">{label}</span>}
          {description && <span className="block text-xs text-muted">{description}</span>}
        </span>
      )}
    </button>
  );
}
